module.exports = __webpack_public_path__ + "img/ring_y_s_null_1@2x.b438dc78.png";